import styled from 'styled-components'
import { Typography } from 'common/typography'
import { useStudentProject } from 'querys/student-projects'

const ProjectIframeStyled = styled.section`
  margin-block-end: 80px;
  iframe {
    height: 56.25vw;
    width: 100vw;
    border: none;
    margin: 0 auto;
    ${({ mobile }) => mobile && `
      width: 100vw;
      height: 100vh;
    `}
  }
  .iframe-container {
    margin-block-start: 40px;
  }
  @media (min-width: 768px) {
    ${({ mobile }) => mobile && `
      iframe {
        display: block;
        width: 414px;
        height: 736px;
      }
    `}
  }
`

function ProjectIframe() {
  const { data, isLoading, isError } = useStudentProject()

  if (isLoading || isError) return null

  const { project_url: url, title, type } = data

  return (
    <ProjectIframeStyled aria-labelledby="implentation" mobile={type === 'MOBILE'}>
      <Typography as="h2" align="center" small="headline5" large="headline4" id="implentation">
        Implementación
      </Typography>
      <div className="iframe-container">
        <iframe src={url} scrolling="no" title={`Implementacion de ${title}`} />
      </div>
    </ProjectIframeStyled>
  )
}

export default ProjectIframe
